import { Dialog } from '@base-ui/react/dialog';
import { XIcon } from '@phosphor-icons/react';
import { Button } from '@admin-panel/ui';
import type { LookContentEditorSection } from './types';

type EnrichmentSectionDialogProps = {
  open: boolean;
  title: string;
  portalContainer?: HTMLElement | null;
  onClose: () => void;
  onReset?: () => void;
  onSave?: () => Promise<void> | void;
  isSaving?: boolean;
  children: React.ReactNode;
  section: LookContentEditorSection | null;
};

const EnrichmentSectionDialog = ({
  open,
  title,
  portalContainer,
  onClose,
  onReset,
  onSave,
  isSaving = false,
  children,
  section,
}: EnrichmentSectionDialogProps) => (
  <Dialog.Root
    open={open}
    onOpenChange={nextOpen => {
      if (!nextOpen) {
        onClose();
      }
    }}
  >
    <Dialog.Portal container={portalContainer ?? undefined}>
      <Dialog.Backdrop className="fixed inset-0 z-[1450] bg-black/35 backdrop-blur-sm" />
      <Dialog.Popup className="fixed inset-0 z-[1451] grid place-items-center p-4 focus-visible:outline-none">
        <div className="flex h-[85vh] max-h-180 w-[min(96vw,1100px)] flex-col overflow-hidden rounded-xl bg-background shadow-2xl ring-1 ring-border/70">
          <header className="flex items-center justify-between border-b border-border/70 px-4 py-3">
            <Dialog.Title className="m-0 text-base font-semibold text-foreground">
              {title}
            </Dialog.Title>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className="inline-flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted/70 hover:text-foreground"
            >
              <XIcon size={16} />
            </button>
          </header>

          <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>

          <footer className="flex items-center justify-end gap-2 border-t border-border/70 px-4 py-3">
            <Button type="button" size="small" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            {section !== 'visual_search' && onReset ? (
              <Button type="button" size="small" variant="outline" onClick={onReset}>
                Reset
              </Button>
            ) : null}
            {section !== 'visual_search' && onSave ? (
              <Button
                type="button"
                size="small"
                onClick={onSave}
                isDisabled={isSaving}
                isLoading={isSaving}
              >
                Save
              </Button>
            ) : (
              <Button type="button" size="small" variant="outline" onClick={onClose}>
                Close
              </Button>
            )}
          </footer>
        </div>
      </Dialog.Popup>
    </Dialog.Portal>
  </Dialog.Root>
);

export default EnrichmentSectionDialog;
